import * as React from 'react';
import {
    Column,
    DataTableData,
    SortDirection,
    CommonDataTableProps
} from './DataTable';
import { CompactControlBar } from './Controls/CompactControlBar';
import { FillPopup } from './Fill/FillPopup';
import { PaginationProps } from './Controls/Pagination/Pagination';
import { Table } from './Table/Table';

export interface CompactDataTableProps<T extends DataTableData>
    extends CommonDataTableProps<T> {
    /**
     * Props for the Pagination component
     */
    paginationProps: PaginationProps;
}

export function CompactDataTable<T extends DataTableData>(
    props: CompactDataTableProps<T>
) {
    return (
        <div id={'orchardDataTable_' + props.idSuffix}>
            <div
                className="simple-data-table-parent copia_color1_b"
                style={{
                    ...props.style,
                    minWidth: Math.max(150 * props.columns.length, 220),
                    borderRadius: '0px 0px 5px 5px',
                    borderTop: 0
                }}
            >
                <Table
                    columns={props.columns}
                    sortColumn={props.sortColumn}
                    onSort={(
                        sortColumn: Column,
                        sortDirection: SortDirection
                    ) => props.handleSort(sortColumn, sortDirection)}
                    sortDirection={props.sortDirection}
                    items={props.displayedData}
                    onInputChange={(
                        itemKey: string,
                        column: Column,
                        value: string
                    ) => props.handleInputColumnChange(itemKey, column, value)}
                    showFillPopup={(column, event) =>
                        props.showFillPopup(column, event)
                    }
                />
                <CompactControlBar pagination={props.paginationProps} />
            </div>
            <FillPopup
                onClose={(fillAll: boolean, value?: string) =>
                    props.fillProps.onClose(fillAll, value)
                }
                show={props.fillProps.show}
                x={props.fillProps.x}
                y={props.fillProps.y}
            />
        </div>
    );
}
